jQuery(document).ready(function($) {

    $(document).on('facetwp-loaded', () => {
        // if($('.facetwp-type-sort select').length) {
        //     $('.facetwp-type-sort select').each(function() {
        //         var $select = $(this);

        //         $select.wrap('<div class="fs-wrap single" tabindex="0"></div>');
        //         $select.after('<div class="fs-label-wrap"><div class="fs-label"></div><span class="fs-arrow"></span></div><div class="fs-dropdown fs-hidden"><div class="fs-options"></div></div>');
                
        //         $select.find('option').each(function() {
        //             var $option = $(this);
        //             var optionHtml = '<div class="fs-option g0" data-value="' + $option.val() + '" data-idx="' + $option.index() + '" tabindex="-1"><span class="fs-checkbox"><i></i></span><div class="fs-option-label">' + $option.text() + '</div></div>';
        //             $select.siblings('.fs-dropdown').find('.fs-options').append(optionHtml);
        //         });
                    
        //         $select.siblings('.fs-label-wrap').find('.fs-label').text($select.find('option:selected').text());
    
        //         // Gestisci il cambio di selezione
        //         $select.change(function() {
        //             var selectedLabel = $select.find('option:selected').text();
        //             $select.siblings('.fs-label-wrap').find('.fs-label').text(selectedLabel);
        //         });
    
        //         // Mostra/nascondi il dropdown al click
        //         $select.siblings('.fs-label-wrap').click(function() {
        //             $(this).siblings('.fs-dropdown').toggleClass('fs-hidden');
        //         });
        //     });
        // }
	});
});